import request from "../../../../core/data/network/client/request";
import Api from "../../../../core/data/network/constants/api_routes";

export default {
  getHistoricalConsum: async (pagination, term) => {
    return request.get(Api.getHistoricalConsum(pagination, term));
  },
  getHistoricalConsumDetail: async (id) => {
    return request.get(Api.getHistoricalConsumById(id));
  }
};